export default __webpack_public_path__ + "static/media/ep11.eb1697c7.jpeg";